module.exports = __webpack_public_path__ + "static/media/johankenzeler.8e47c2cb.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/johankenzeler.webp
// module id = 343
// module chunks = 0